import { render, staticRenderFns } from "./neworder.vue?vue&type=template&id=7d216431"
import script from "./neworder.vue?vue&type=script&lang=js"
export * from "./neworder.vue?vue&type=script&lang=js"
import style0 from "./neworder.vue?vue&type=style&index=0&id=7d216431&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports